//IdcForm
export const Idc = "idc";
export const IdCardExpireDate = "expDate";

//CRS
export const CRSBirthAddressKey = "crsBirthAddress";
export const CRSDeclareLocationKey = "crsDeclareLocation";
export const CRSData = "crsData";
export const CRSEditData = "crsEditData";
export const CRSUnSaveRadioCheck = "CrsUnSaveRadioChecked";
export const CRSRadioChecked = "CrsRadioChecked";
export const DeleteFlag = "DeleteFlag";
export const EditFlag = "EditFlag";

//HeaderManp
export const HeaderManpKey = "HeaderManp";

//Components
export const IsMoreInfo = "IsMoreInfo";
export const CRSConsent = "CRSConsent";

//Master
export const Master = {
    countryList: "CountryList"
};